import { render, staticRenderFns } from "./UserRoleManager.vue?vue&type=template&id=6f2968c1&scoped=true&"
import script from "./UserRoleManager.vue?vue&type=script&lang=js&"
export * from "./UserRoleManager.vue?vue&type=script&lang=js&"
import style0 from "./UserRoleManager.vue?vue&type=style&index=0&id=6f2968c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2968c1",
  null
  
)

export default component.exports